import { memo } from "react";
import { formatToValue } from "../../../../utils/formatNumber";
import { CustomChartToolTip } from "../../styles/DashBoard";

const Tooltip = ({ active, payload, label, groupedDate }) => {
  if (!active || !payload?.length) return null;

  return (
    <CustomChartToolTip>
      <p>
        {groupedDate === "week" ? "Semana de" : "Data"}: {label}
      </p>
      {payload.map((index) => (
        <p key={index.name} style={{ color: index.color }}>
          {index.name}: R$ {formatToValue(index.value)}
          {"\n"}
        </p>
      ))}
    </CustomChartToolTip>
  );
};

export default memo(Tooltip);
